import React from "react"
import { Container } from 'reactstrap'

export const ValuesPage = ({RenderValues, coreValues, supportValues, drivers, characterValues}) => {
    return (
        <Container>
            <h1>Welcome to Your JobPassionDNA&trade;</h1>
            <h2>Your Values. Your Vibe. Your Career Power-Up.</h2>
            <p>You've just unlocked something big.</p>
            <p>
                Out of all the different value statements, you picked the ones that best reflect who you are.
                That wasn't random. That was your brain and heart syncing up to reveal what actually drives you.
            </p>
            <p>
                Think of your values like your personal inner compass. They guide you in making choices, who you
                vibe with, and what type of work will feel exciting vs. soul-sucking.
            </p>

            <h2>Here's why it matters:</h2>
            <p>
                When your job lines up with your values, you're more likely to feel fulfilled, energized, and straight-up
                happy. When they don't? Cue burnout, stress, and the "why am I even doing this?" moments.
            </p>
            <p>
                We've organized your values into four key categories; Core, Sanctioning and Character Values. At the heart
                of their intersection, we'll find your ideal type of work you'll likely enjoy doing.
            </p>
            <p>
                Core and Supporting Values are used to define your unique combination of Job Passion Types. While
                Sanctioning and Character values serve as filters to help you make the best choice between different
                job opportunities that align with your Job Passion Types.
            </p>
            <p>
                You'll discover more about how to use your values to screen for your ultimate job that would be a dream
                for you to do in the Appendix of this report.
            </p>

            
            <h2>🔥 Core Values = Your Non-Negotiables</h2>
            <p>
                These are the values that show up in almost every decision you make — your daily defaults. You will follow
                these values almost without exception, regardless of the situation.
            </p>
            <p>
                <strong>Example:</strong> If "honesty" is a Core Value, you speak the truth no matter what, even if it's uncomfortable.
            </p>
            <p>Based on your response, here are your core values that govern your life.</p>

            <RenderValues valueType="core" valueName="Core" valueList={coreValues.concat(supportValues)} headBg="#3f6caf" rowBg1="#c5cee2" rowBg2="#e3e8f2"
                emptyDesc="🛑 No Core Values detected? No worries. If this happens, you might be in a phase of figuring things out, which is totally normal. "/>
            <p>
            </p>

            <h2>🚦 Sanctioning Values = Your Hard Pass Filters</h2>
            <p>
                These values are your personal deal-breakers. A job might look amazing on paper, but if it messes with a Sanctioning
                Value, you'll feel off.
            </p>
            <p>
                <strong>Example:</strong> Let's say "family time" is one of your values.
                <ul>
                    <li>A gig that keeps you traveling four nights a week? Nope.</li>
                    <li>One that lets you be home for dinner? Yes, please.</li>
                </ul>
            </p>
            <p>
                You'll find an explanation of all the Sanctioning values and how to use them to help you make "go" versus "no go" decisions in the Appendix.
            </p>
            <p>Here are YOUR Sanctioning values based on your responses to the assessment.</p>

            <RenderValues valueType="driver" valueName="Sanctioning" valueList={drivers} headBg="#8bb148" rowBg1="#d6e3c7" rowBg2="#ebf1e4" />

            <h2>🧩 Character Values = Your Work Style Clues</h2>
            <p>
                These describe <i>how</i> you like to operate on the job; your personal work style values.
            </p>
            <p>
                <strong>Example:</strong> Let's say punctuality is one of your Character Values.
                <ul>
                    <li>A job with clear schedules and structured timelines? Feels like home.</li>
                    <li>But a chaotic work environment with last-minute changes and constant fire drills? That's a hard pass.</li>
                </ul>
            </p>
            <p>
                The Appendix includes a complete list of all the Character values and an explanation of how to use them as a filter
                to choose the best job fit for you.
            </p>
            <p>
                The Appendix includes a complete list of all the Character values and an explanation of how to
                use them as a filter to discover the best job fit.
            </p>
            <p>Based on your responses to the assessment, here are your Character values.</p>

            <RenderValues valueType="qualifier" valueName="Character" valueList={characterValues} headBg="#fdb50a" rowBg1="#ffefc1" rowBg2="#fee287" />

            <h2>Summary</h2>
            <p>
                You now have a personalized values map that can guide your next move in the game of life. Whether you're choosing a career,
                a side quest, or your next boss. Your values help you dodge bad fits and lock onto roles where you'll actually thrive.
            </p>
            <p>
                When your values align with a company's mission and culture, it just clicks. Work feels easier, more fun, and more like you're
                leveling up, not just clocking in. On the flip side, if your values don't match the company's mission or your manager's mindset,
                it can feel like you're playing on the wrong team; frustrating, stressful, and totally out of sync. You'll feel off, drained,
                and out of alignment.
            </p>

            <h2>What's Next</h2>
            <p>
                Ready to find your fit? Hit that button to <strong>discover your Job Passion Types</strong>. Your Job Passion Types are the
                "at work roles" that align with your values and mindset, helping you do work that feels natural, exciting, and totally you.
                This is where your energy meets opportunity!
            </p>
            
            <div>&nbsp;</div>
        </Container>
    )
}